import { useParams } from 'react-router-dom';

export function getVisitRoutePath(stayId: string, visitId: string, selectedBucketId?: string, selectedBucketItemId?: string) {
	if (selectedBucketItemId && !selectedBucketId) {
		throw new Error('selectedBucketId is required when selectedBucketItemId is provided');
	}
	return selectedBucketItemId
		? `/visits/${stayId}/${visitId}/${selectedBucketId}/${selectedBucketItemId}`
		: selectedBucketId
		? `/visits/${stayId}/${visitId}/${selectedBucketId}`
		: `/visits/${stayId}/${visitId}`;
}

export type VisitPageParamsValues = {
	stayId: string;
	visitId: string;
	selectedBucketId?: string;
	selectedBucketItemId?: string;
};

export function useVisitPageParams(): VisitPageParamsValues {
	const params = useParams<'stayId' | 'visitId' | 'selectedBucketId' | 'selectedBucketItemId'>();
	if (!params.stayId || !params.visitId) {
		throw new Error('stayId and visitId are required in the URL parameters');
	}
	return {
		stayId: params.stayId,
		visitId: params.visitId,
		selectedBucketId: params.selectedBucketId,
		selectedBucketItemId: params.selectedBucketItemId
	} satisfies VisitPageParamsValues;
}
